export class ShareEmailService {
	constructor($mdDialog, CommonConstants, $timeout, vcRecaptchaService, messagingService, captchaService) {
		'ngInject';
		this.$mdDialog = $mdDialog;
		this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		this.model = {};
		this.showShareSuccess = false;
		this.CommonConstants = CommonConstants;
		this.vcRecaptchaService = vcRecaptchaService;
		this.$timeout = $timeout;
		this.messagingService = messagingService;
		this.captchaService = captchaService;
		this.location = window.location.href;
	}
	initCaptcha() {
		this.captchaService.getCaptcha().then(
			response => {
				this.captchaId = response.data.captchaId;
				this.captchaImg = response.data.htmlFragment;
			},
			error => {
				window.ipEventBus.publish('show-error', {
					message: 'technicalError'
				});
			}
		);
	}
	resetCaptchaError() {
		this.shareForm.captcha.$setValidity('invalid', true, this.shareForm)
	}
	openMessageForm({ comissionId }) {
		this.comissionId = comissionId;
		this.showShareSuccess = false;
		this.showShareError = false;
		let param = {
			event: 'sharePropertyLink',
			propertyID: this.comissionId
		};
		window.dataLayer.push(param);
		const vm = this;
		this.$mdDialog
			.show({
				templateUrl: 'share-in-email-popup.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl',
				onComplete() {
					vm.captchaText = null;
					vm.initCaptcha();
				}
			})
			.finally(() => {
				window.dataLayer.push({
					event: 'propertyShareModalClose'
				});
				this.closeShareDialog();
			});
	}
	send() {
		window.dataLayer.push({
			event: 'sendPropertyLink',
			propertyID: this.comissionId
		});
		this.model.fav = this.favourite ? this.favourite : '';
		this.model.comissionId = this.comissionId ? this.comissionId : '';
		this.sendShareEmail();
	}
	closeShareDialog(type) {
		this.$mdDialog.cancel();
		this.showShareSuccess = false;
		this.model = {};
	}
	sendShareEmail() {
		this.shareResponse = '';

		this.model.url = this.location;
		this.messagingService
			.sendMessageToPerson(this.model, { captchaId: this.captchaId, captchaText: this.captchaText })
			.then(response => {
				if (response.status == 200) {
					this.shareResponse = true;
					this.showShareSuccess = true;
				}
			})
			.catch((error) => {
				if (error.status == 400 && error.data?.error == 'captcha') {
					this.shareForm.captcha.$setValidity('invalid', false, this.shareForm);
					this.shareForm.captcha.$setPristine();
					this.shareForm.captcha.$setUntouched();
					this.captchaText = null;
					this.initCaptcha();
				} else {
					this.showShareError = true;
				}
			});
	}
}
